module.exports = __webpack_public_path__ + "img/a441c5b.jpg";